<div class="pill-content">
  <ng-content></ng-content>
</div>